import { useState, forwardRef } from "react"

const HowItWorks = forwardRef<HTMLElement>((props, ref) => {
  const videoId = "gjr20aijiU8"
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}`
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`
  const [isHovered, setIsHovered] = useState(false)

  return (
    <section
      ref={ref}
      className="w-full pt-15 md:pt-[100px] pb-[50px] flex flex-col items-center text-dark-primary px-5"
    >
      <h2 className="text-2xl sm:text-3xl md:text-4xl tracking-tight">
        How it <span className="font-display">Works</span>
      </h2>
      <div
        className="w-full lg:w-[1060px] aspect-video mt-5 md:mt-7.5 rounded-xl md:rounded-2xl lg:rounded-[40px] overflow-hidden cursor-pointer relative"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <a href={videoUrl} target="_blank" rel="noopener noreferrer">
          {!isHovered ? (
            <img
              className="w-full h-full object-cover absolute inset-0"
              src="https://storage.googleapis.com/myblankspace-prod/assets/vid.png"
              alt="Video preview"
            />
          ) : (
            <iframe
              className="w-full h-full absolute inset-0"
              src={embedUrl}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        </a>
      </div>
    </section>
  )
})

HowItWorks.displayName = "HowItWorks"
export default HowItWorks
